module.exports = __webpack_public_path__ + "static/media/Rectangle 11.c14b4fc1.png";